import React from 'react';
import DOMPurify from 'dompurify';
import './styles.css';

interface SafeHtmlRendererProps {
  htmlContent: string;
  className?: string;
}

export const SafeHtmlRenderer: React.FC<SafeHtmlRendererProps> = ({ 
  htmlContent, 
  className = '' 
}) => {
  const sanitizedHtml = DOMPurify.sanitize(htmlContent, {
    ALLOWED_TAGS: [
      'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 
      'p', 
      'strong', 'b',
      'em', 'i',
      'u', 
      'ul', 'ol', 'li', 
      'br', 
      'a',
      'span',
      'div',
      'blockquote',
      'pre',
      'code'
    ],
    ALLOWED_ATTR: ['href', 'target', 'rel', 'class', 'style']
  });

  return (
    <div 
      className={`rendered-html ${className}`}
      dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
    />
  );
};
